import { AxiosInstance } from 'axios';
import { SHIFT_SERVICE_API_ENDPOINT } from '@/constant';
import AbsenceCategoriesRepository from '@/repository/shift-service/absence-categories/absenceCategoriesRepository';
import BackdoorRepository from '@/repository/shift-service/backdoor/backdoorRepository';
import ChildClassesRepository from '@/repository/shift-service/child-classes/childClassesRepository';
import ChildGroupsRepository from '@/repository/shift-service/child-groups/childGroupsRepository';
import ClassGroupWorkplaceRepository from '@/repository/shift-service/class-group-workplace/classGroupWorkplaceRepository';
import ClassWorkplaceRepository from '@/repository/shift-service/class-workplace/classWorkplaceRepository';
import DatesRepository from '@/repository/shift-service/shift-dates/shiftDatesRepository';
import DutiesRepository from '@/repository/shift-service/duties/dutiesRepository';
import DutyOrdersRepository from '@/repository/shift-service/duty-orders/dutyOrdersRepository';
import GroupWorkplaceRepository from '@/repository/shift-service/group-workplace/groupWorkplaceRepository';
import SettingsRepository from '@/repository/shift-service/settings/settingsRepository';
import ShiftCategoriesOrderRepository from '@/repository/shift-service/shift-category-orders/shiftCategoriesOrderRepository';
import ShiftCategoriesRepository from '@/repository/shift-service/shift-categories/shiftCategoriesRepository';
import ShiftPatternsOrderRepository from '@/repository/shift-service/shift-pattern-orders/shiftPatternsOrderRepository';
import ShiftPatternsRepository from '@/repository/shift-service/shift-patterns/shiftPatternsRepository';
import ShiftCountRepository from '@/repository/shift-service/shift-count/shiftCountRepository';
import SimpleSettingsRepository from '@/repository/shift-service/simple-settings/simpleSettingsRepository';
import StaffingLevelsRepository from '@/repository/shift-service/staffing-levels/staffingLevelsRepository';
import WorkplacesRepository from '@/repository/shift-service/workplaces/workplacesRepository';

export default (axios: AxiosInstance) => {
  const absenceCategoriesRepository = AbsenceCategoriesRepository(axios);
  const backdoorRepository = BackdoorRepository(axios);
  const childClassesRepository = ChildClassesRepository(axios);
  const childGroupsRepository = ChildGroupsRepository(axios);
  const classGroupWorkplaceRepository = ClassGroupWorkplaceRepository(axios);
  const classWorkplaceRepository = ClassWorkplaceRepository(axios);
  const datesRepository = DatesRepository(axios);
  const dutiesRepository = DutiesRepository(axios);
  const dutyOrdersRepository = DutyOrdersRepository(axios);
  const groupWorkplaceRepository = GroupWorkplaceRepository(axios);
  const settingsRepository = SettingsRepository(axios);
  const shiftCategoriesOrderRepository = ShiftCategoriesOrderRepository(axios);
  const shiftCategoriesRepository = ShiftCategoriesRepository(axios);
  const shiftPatternsOrderRepository = ShiftPatternsOrderRepository(axios);
  const shiftPatternsRepository = ShiftPatternsRepository(axios);
  const shiftCountRepository = ShiftCountRepository(axios);
  const simpleSettingsRepository = SimpleSettingsRepository(axios);
  const staffingLevelsRepository = StaffingLevelsRepository(axios);
  const workplacesRepository = WorkplacesRepository(axios);

  return {
    absenceCategories: absenceCategoriesRepository(`${SHIFT_SERVICE_API_ENDPOINT.ABSENCE_CATEGORIES}`),
    backdoor: backdoorRepository(`${SHIFT_SERVICE_API_ENDPOINT.BACKDOOR}`),
    childClasses: childClassesRepository(`${SHIFT_SERVICE_API_ENDPOINT.CHILD_CLASSES}`),
    childGroups: childGroupsRepository(`${SHIFT_SERVICE_API_ENDPOINT.CHILD_GROUPS}`),
    classGroupWorkplace: classGroupWorkplaceRepository(`${SHIFT_SERVICE_API_ENDPOINT.CLASS_GROUP_WORKPLACE}`),
    classWorkplace: classWorkplaceRepository(`${SHIFT_SERVICE_API_ENDPOINT.CHILD_WORKPLACE}`),
    shiftDates: datesRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_DATES}`),
    duties: dutiesRepository(`${SHIFT_SERVICE_API_ENDPOINT.DUTIES}`),
    dutyOrders: dutyOrdersRepository(`${SHIFT_SERVICE_API_ENDPOINT.DUTY_ORDERS}`),
    groupWorkplace: groupWorkplaceRepository(`${SHIFT_SERVICE_API_ENDPOINT.GROUP_WORKPLACE}`),
    settings: settingsRepository(`${SHIFT_SERVICE_API_ENDPOINT.SETTINGS}`),
    shiftCategories: shiftCategoriesRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_CATEGORIES}`),
    shiftCategoriesOrder: shiftCategoriesOrderRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_CATEGORY_ORDERS}`),
    shiftPatterns: shiftPatternsRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_PATTERNS}`),
    shiftCount: shiftCountRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_COUNT}`),
    shiftPatternsOrders: shiftPatternsOrderRepository(`${SHIFT_SERVICE_API_ENDPOINT.SHIFT_PATTERN_ORDERS}`),
    simpleSettings: simpleSettingsRepository(`${SHIFT_SERVICE_API_ENDPOINT.SIMPLE_SETTINGS}`),
    staffingLevels: staffingLevelsRepository(`${SHIFT_SERVICE_API_ENDPOINT.STAFFING_LEVELS}`),
    workplaces: workplacesRepository(`${SHIFT_SERVICE_API_ENDPOINT.WORKPLACES}`),
  };
};
